import { Component, OnInit } from '@angular/core';
import { CommsService } from '../../services/comms/comms.service';
import { UserService } from '../../services/user/user.service';
import { DataService } from '../../services/data/data.service';
import { ConfigService } from '../../services/config/config.service';

@Component({
	selector: 'pcm-admin-users',
	templateUrl: './admin-users.component.html',
	styleUrls: ['./admin-users.component.scss']
})
export class AdminUsersComponent implements OnInit {

	title = 'Users';

	removeModalTitle = 'Revoke Selected Users';
	helpText = 'Please enter comments to revoke the selected users\' access';

	showForm = false;
	showExportModal = false;
	dataObj = this.userService.dataObj;
	tableColumns = [];

	constructor(
		public configService: ConfigService,
		private commsService: CommsService,
		public userService: UserService,
		public dataService: DataService
	) { }

	ngOnInit() {
		this.tableColumns = this.configService.getTableFields(this.dataObj, false);
		this.userService.selectDefaultTab(this.userService.tabsData.listTabs);
		this.userService.dataConfig = this.configService.getDataObj(this.dataObj);
		this.userService.tableConfig = this.configService.getTableFields(this.dataObj, false);
		this.userService.actions = this.configService.getActions(this.dataObj);
		this.userService.actionsForAll = this.userService.actions.slice(1);	// dont need revalidate action
		this.userService.removeDataConfig = this.configService.getDataObj(this.userService.removeDataObj);
		this.dataService.updateUserRemoveDetails(this.dataService.emptyFields(this.userService.removeDataConfig));
	}

	allowAction = () => {
		return this.dataService.selectedTableRows[0] !== undefined;
	}

	takeAction(event) {
		console.log('TAKE ACTION', event);
		if (event.action.prop === 'revalidateusers') {
			this.revalidateUsers();
		} else if (event.action.prop === 'exporttocsv') {
			this.showExportModal = true;
		} else {
			this.userService.showRemoveModal = true;
		}
	}

	modalCancel(event) {
		console.log('USERS REMOVE CANCEL', event);
		this.userService.showRemoveModal = false;
	}

	removeSubmit(event) {
		console.log('USERS REMOVE SUBMIT', event);

		const users = [];
		this.dataService.selectedTableRows.forEach((row) => {
			const user = {
				email: row.email,
				org: row.org
			};
			users.push(user);
		});

		const data = event.data;
		data['users'] = users;
		console.log('REVOKE USERS', data);
		this.userService.revokeUsers(data);
	}

	revalidateUsers() {
		const users = [];
		this.dataService.selectedTableRows.forEach((row) => {
			const user = {
				email: row.email,
				org: row.org
			};
			users.push(user);
		});

		console.log('REVALIDATE USERS', users);
		this.userService.revalidateUsers(users);
	}

	newUser() {
		this.showForm = true;
		const data = {
			email: ''
		};
		this.dataService.updateUserRequestDetails(data);
	}

	onShowAddUsers() {
		this.userService.showAddUsersModal = true;
		this.userService.resetAddUsers();
	}

	onCloseAddUserModel(event) {
		console.log(event);
		this.userService.showAddUsersModal = false;
	}

	userErrorCancel(event) {
		this.userService.showFailedUsers = false;
	}

	closeExportModal() {
		this.showExportModal = false;
	}

	exportToCSV(event) {
		this.commsService.exportToCSV(event.data, this.userService.tableConfig, this.dataService.selectedTableRows);
		const self = this;
		const delay = setTimeout(function () {
			self.closeExportModal();
		}, 1000);
	}
}

